export const LATENCY_STAGE_ORDER = [
  'speech_ended',
  'vad_fired',
  'recording_stop_requested',
  'recording_stopped',
  'blob_finalized',
  'upload_started',
  'upload_completed',
  'stt_started',
  'stt_completed',
  'llm_started',
  'llm_first_token',
  'llm_completed',
  'tts_started',
  'tts_first_byte',
  'tts_completed',
  'playback_started',
  'playback_completed',
];

export const createLatencyWaterfall = (turnId) => ({ turnId, marks: {}, details: {}, updatedAt: new Date().toISOString() });

export const markLatencyStage = (waterfall, stage, atMs = performance.now(), detail = {}) => {
  if (!waterfall.marks[stage]) waterfall.marks[stage] = atMs;
  waterfall.details[stage] = { ...waterfall.details[stage], ...detail };
  waterfall.updatedAt = new Date().toISOString();
  return waterfall;
};

export const serializeLatencyWaterfall = (waterfall) => {
  if (!waterfall) return [];
  const markValues = Object.values(waterfall.marks);
  if (!markValues.length) return [];
  const baseline = waterfall.marks.speech_ended || Math.min(...markValues);
  return LATENCY_STAGE_ORDER
    .filter((stage) => waterfall.marks[stage])
    .map((stage, index, stages) => {
      const previousStage = stages[index - 1];
      return {
        stage,
        atMs: Math.round(waterfall.marks[stage] - baseline),
        durationMs: previousStage ? Math.round(waterfall.marks[stage] - waterfall.marks[previousStage]) : 0,
        ...waterfall.details[stage],
      };
    });
};

export const summarizeLatencyWaterfall = (waterfall) => {
  const marks = waterfall?.marks || {};
  const fromSpeechEnd = (stage) => marks.speech_ended && marks[stage] ? Math.round(marks[stage] - marks.speech_ended) : null;
  const technicalLatencyMs = fromSpeechEnd('playback_started');
  const perceivedLatencyMs = fromSpeechEnd('acknowledged');
  return {
    technicalLatencyMs,
    perceivedLatencyMs,
    withinTarget: technicalLatencyMs === null ? null : technicalLatencyMs < 2500,
    regression: technicalLatencyMs === null ? false : technicalLatencyMs > 4000,
  };
};